import { PetsService } from './../../../auth/_services/pets.service';
import { Pet } from './../../../auth/_models/pet';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { SessionService } from 'src/app/auth/_services/session.service';
import { User } from 'src/app/auth/_models/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { UsersService } from 'src/app/auth/_services/users.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-my-pets-list',
  templateUrl: './my-pets-list.component.html',
  styleUrls: ['./my-pets-list.component.css'],
  providers: [UsersService]
})
export class MyPetsListComponent implements OnInit, OnDestroy {

  guardian: User;
  pets: Pet[];
  email;
  unSubscribe = new Subject;

  constructor(
    private _petService: PetsService,
    private _authService: AuthenticationService,
    private _userService: UsersService,
  ) {
    this.guardian = new User();
    this.pets = new Array<Pet>();
  }

  ngOnInit() {

    this._authService.firebaseUser
      .pipe(takeUntil(this.unSubscribe))
      .subscribe(userAuth => {
        this._userService.getUserById(userAuth.uid)
          .pipe(takeUntil(this.unSubscribe))
          .subscribe(user => {
            this.guardian = user;
            this._petService.getGuardianPets(this.guardian.email)
              .pipe(takeUntil(this.unSubscribe))
              .subscribe(pets => {
                this.pets = pets;
              });
          });
      });

  }

  ngOnDestroy() {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }

}
